import { suspendOn } from '@openphone/lib/suspendOn'
import { observer } from 'mobx-react-lite'
import { Navigate } from 'react-router-dom'

import { useAppStore } from '@src/app/context'
import { UniversalLoginRoute } from '@src/app/universal-login'

const AuthGuard = ({ children }: { children: React.ReactNode }) => {
  const app = useAppStore()

  if (!app.isLoggedIn) {
    return <UniversalLoginRoute />
  }

  if (!app.initialized || !app.storesLoaded) {
    suspendOn(app.initializePromise)
  }

  if (app.isAccountFlagged) {
    return <Navigate to="/verification/flagged" />
  }

  return <>{children}</>
}

export default observer(AuthGuard)
